import { createSelector } from "@ngrx/store";

import * as fromRoot from "#core/router-store";
import { Asset } from "@carnegie-learning/cure-types";
import * as fromFeature from "../reducers";
import * as fromAssets from "../reducers/student-assets.reducer";

export const getAssetsState = createSelector(
    fromFeature.getStudentCoursesModuleState,
    (state: fromFeature.StudentCoursesState) => state.studentAssets
);

export const getAssetsEntities = createSelector(
    getAssetsState,
    fromAssets.getAssetsEntities
);

export const getStudentAssets = createSelector(getAssetsEntities, (entities) => {
    return Array.from(entities.values());
});

export const getSelectedAsset = createSelector(
    // asset state (list of all assets)
    getAssetsEntities,
    getAssetsState,
    // url state (current url)
    fromRoot.getRouterState,
    // returns the asset based off url param
    (entities, assetState, router): Asset | null => {
        if (router) {
            const entity = entities.get(router.state.params.assetId);
            if (entity !== undefined) {
                return router.state && entity;
            } else {
                return router.state && fromAssets.getSelectedAsset(assetState);
            }
        } else {
            return null;
        }
    }
);

export const getSelectedAssetLoading = createSelector(
    getAssetsState,
    fromAssets.getSelectedAssetLoading
);

export const getSelectedAssetLoaded = createSelector(
    getAssetsState,
    fromAssets.getSelectedAssetLoaded
);

export const getSelectedAssets = createSelector(
    getAssetsState,
    fromAssets.getSelectedAssets
);

export const getAssetsLoading = createSelector(
    getAssetsState,
    fromAssets.getAssetsLoading
);

export const getAssetsLoaded = createSelector(
    getAssetsState,
    fromAssets.getAssetsLoaded
);

export const getAssetPaginationParams = createSelector(
    getAssetsState,
    fromAssets.getAssetPaginationParams
);

export const getRawAssetsResponse = createSelector(
    getAssetsState,
    fromAssets.getRawAssetsResponse
);
